import React, { useEffect, useState, useCallback } from 'react';
import * as _ from 'lodash';
import './top-posts-container.scss';
import { default as t } from '../../../utils/i18n';
import { ReactComponent as NoPreview } from '../../../assets/svg/no_preview.svg';

function TopPostsContainer({ data, kpiList, fromSnapShot, snapShotUrls, isLowPosts=false }) {

  const getIframeURL = useCallback((value)=>{
    if (value) {
      const htmlDom = new DOMParser().parseFromString(value, 'text/html');
      let width = htmlDom.getElementsByTagName('iframe')[0].getAttribute('width');
      if (width <= 320) {
        htmlDom.getElementsByTagName('iframe')[0]?.setAttribute('scrolling', 'no');
      } else {
        htmlDom.getElementsByTagName('iframe')[0]?.setAttribute('width', '320');
        htmlDom.getElementsByTagName('iframe')[0]?.setAttribute('height', '525');
      }
      return htmlDom.documentElement.innerHTML;
    } else {
      return '';
    }
  },[])
  const convertValue = (value) => {
    return Number(value)?.toLocaleString();
  }

  const getCurrentPosts = () => {
    return isLowPosts ? data?.reportData?.low_performing_ads : data?.reportData?.top_performing_ads;
  }

  return (
    <>
      {getCurrentPosts()?.length > 0 ? (
        <div className="post-container">
          { !fromSnapShot ? 
          getCurrentPosts()?.map((post, index) => (
            <div key={index + 'top'} className="post-card">
              <div className="image">
                {post?.iframe ? (
                    <p dangerouslySetInnerHTML={{ __html: getIframeURL(post?.iframe) }}></p>
                ) : (
                  <div className="no-preview">
                    <NoPreview />
                    <p>{t('top.posts.no.preview')}</p>
                  </div>
                )}
              </div>
              <div className="line"></div>
              <div className="info">
                <div>
                <p>{t('top.posts.ad.name')}</p>
                  <span title={post?.ad_name || 'N/A'}>{post?.ad_name || 'N/A'}</span>
                </div>
                {post?.metrics?.map((metric, index) => (
                  <div key={index + 'metric'}>
                    <p
                      title={
                        kpiList.length > 0 &&
                        kpiList?.filter(x => x?.sys_id === metric?.key)[0]?.KPI_Metric
                      }
                    >
                      {kpiList.length > 0 &&
                        kpiList?.filter(x => x?.sys_id === metric?.key)[0]?.KPI_Metric}
                    </p>
                    <span>{metric?.value ? convertValue(Number(metric?.value)?.toFixed(2)) : 'N/A'}</span>
                  </div>
                ))}
              </div>
            </div>
          )) :
          snapShotUrls?.map((post, index) => (
            <div key={index + 'top'} className="post-card">
              <div className="image">
                {post?.presigned_url ? (
                  <img src={post?.presigned_url} alt="logo" crossOrigin="anonymous" />
                ) : (
                  <div className="no-preview">
                    <NoPreview />
                    <p>{t('top.posts.no.preview')}</p>
                  </div>
                )}
              </div>
              <div className="line"></div>
              <div className="info">
                <div>
                  <p>{t('top.posts.ad.name')}</p>
                  <span title={post?.ad_name || 'N/A'}>{post?.ad_name || 'N/A'}</span>
                </div>
                {post?.metrics?.map((metric, index) => (
                  <div key={index + 'metric'}>
                    <p
                      title={
                        kpiList.length > 0 &&
                        kpiList?.filter(x => x?.sys_id === metric?.key)[0]?.KPI_Metric
                      }
                    >
                      {kpiList.length > 0 &&
                        kpiList?.filter(x => x?.sys_id === metric?.key)[0]?.KPI_Metric}
                    </p>
                    <span>{metric?.value ? convertValue(Number(metric?.value)?.toFixed(2)) : 'N/A'}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div>
          {!isLowPosts && <span className="no-post">{t('report.noTopPost')}</span>}
          {isLowPosts && <span className="no-post">{t('No data available')}</span>}
        </div>
      )}
    </>
  );
}

export default React.memo(TopPostsContainer, _.isEqual);
